import { GenericAiWidgetData, WidgetData } from '../../types'
import { WidgetService } from './widgetService'
import { ReadableWidgetService } from './interfaces/readableWidgetService'
import { WidgetOutputMode } from '../../enums'

interface GenericAiWidgetService extends WidgetService, ReadableWidgetService {
  /**
   * Set the value of the widget. Updates the timestamp as well.
   * @param value The new value
   */
  setValue(value: string | undefined): void
}

/**
 * Create a Widget Service for a Generic AI Widget
 * @param widget The widget data
 * @returns The Widget Service instance
 * @story User Story 10482: Generic Prompt AI widget: select output mode: add or replace
 */
export const getGenericAiWidgetService = (widget: WidgetData) => {
  // Cast the widget to the correct type
  const genericAiWidget: GenericAiWidgetData = widget as GenericAiWidgetData

  // Return the service instance
  return {
    getReadableText() {
      // No need to read the text if it replaces recommendation text,
      // as it is not displayed in the widget itself then
      const outputMode = genericAiWidget?.outputMode || WidgetOutputMode.Add
      return outputMode === WidgetOutputMode.Add ? (genericAiWidget?.value ?? '') : ''
    },
    setValue(value) {
      genericAiWidget.value = value
      genericAiWidget.updatedAt = Date.now()
    },
  } as GenericAiWidgetService
}
